import './helper-text.css';
export default {
  "helperText": "pf-v6-c-helper-text",
  "helperTextItem": "pf-v6-c-helper-text__item",
  "helperTextItemIcon": "pf-v6-c-helper-text__item-icon",
  "helperTextItemText": "pf-v6-c-helper-text__item-text",
  "modifiers": {
    "hidden": "pf-m-hidden",
    "indeterminate": "pf-m-indeterminate",
    "warning": "pf-m-warning",
    "success": "pf-m-success",
    "error": "pf-m-error",
    "dynamic": "pf-m-dynamic"
  }
};